import type { ProxyUser } from '../types';

const CREATE_USER_PREFIX = '__create_proxy_user__:';

export interface ProxyUserSelectOption {
  value: number | string;
  label: string;
}

export const buildProxyUserSelectOptions = (
  users: ProxyUser[],
  keyword: string,
  settledKeyword: string,
  loading: boolean,
  creating: boolean,
): ProxyUserSelectOption[] => {
  const userOptions = users.map((user) => ({
    value: user.id,
    label: user.wechat_id
      ? `${user.wechat_nickname} · ${user.wechat_id}`
      : user.wechat_nickname,
  }));
  const nickname = keyword.trim();

  if (
    userOptions.length > 0
    || !nickname
    || loading
    || creating
    || settledKeyword.trim() !== nickname
  ) {
    return userOptions;
  }

  return [{
    value: `${CREATE_USER_PREFIX}${nickname}`,
    label: `创建用户「${nickname}」`,
  }];
};

export const parseCreateProxyUserValue = (value: number | string | undefined): string | null => {
  if (typeof value !== 'string' || !value.startsWith(CREATE_USER_PREFIX)) return null;
  return value.slice(CREATE_USER_PREFIX.length).trim() || null;
};
